<template>
  <div class="activate-table-spinner-component">
    <div class="flex flex-row w-[155px] h-[35px] text-wrap-initial">
      <div class="w-[24px] h-full flex items-center justify-center mr-[5px]">
        <font-awesome-icon :class="['animate-spin w-[18px] h-[18px] text-black', stylingClasses]" icon="fa-solid fa-circle-notch"/>
      </div>
      <div class="flex items-center justify-center whitespace-normal">{{text}}</div>
    </div>
  </div>
</template>

<script src="./table-column-spinner.js"></script>
